module.exports = __webpack_public_path__ + "static/media/Frame2.52fd63a2.png";